import { createAuthClient } from "better-auth/react"
import { emailOTPClient, magicLinkClient, organizationClient } from "better-auth/client/plugins"

export const authClient = createAuthClient({
    baseURL: import.meta.env.VITE_API_URL,
    plugins: [emailOTPClient(), magicLinkClient(), organizationClient()],
    emailAndPassword: {
        enabled: true,
    },
})

export const useSession = authClient.useSession